import { BAOCustomElement } from '@bao/custom-element'

class ProductLabels extends BAOCustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.defaultName = this.els.name?.element.dataset.default
      ? this.els.name.element.dataset.default
      : ''
  }

  setupListeners () {
    this.handleMouseEnter = this.handleMouseEnter.bind(this)
    this.handleMouseLeave = this.handleMouseLeave.bind(this)

    this.els.item.elements.forEach((item) => {
      this.listeners.add(item, 'mouseenter', this.handleMouseEnter)
      this.listeners.add(item, 'mouseleave', this.handleMouseLeave)
    })
  }

  handleMouseEnter (event) {
    const name = event.currentTarget.dataset.name

    this.els.name.element.textContent = name

    if (this.els.legend?.exists && name !== this.defaultName) {
      this.els.legend.element.classList.add('prd-Options_Legend-tempName')
    }
  }

  handleMouseLeave () {
    this.els.name.element.textContent = this.defaultName

    if (this.els.legend?.exists) {
      this.els.legend.element.classList.remove('prd-Options_Legend-tempName')
    }
  }
}

if (!customElements.get('product-labels')) {
  customElements.define('product-labels', ProductLabels)
}
